import {AfterViewInit, Component, ViewChild, inject} from '@angular/core';
import {
  RichTextEditorComponent,
  RichTextEditorAllModule
} from '@syncfusion/ej2-angular-richtexteditor';
import {EmojiPickerService} from '../../../shared/services/emoji-picker.service';

@Component({
    selector: 'app-emoji-picker',
    imports: [RichTextEditorAllModule],
    template: `
  <!-- Small reaction picker overlay host -->
  <div id="reaction-overlay-host"></div>
  <div id="emoji-picker-host">
    <ejs-richtexteditor
      #emojiRTE
      [toolbarSettings]="toolbarSettings"
      style="position:absolute; left:-9999px; top:-9999px;"
    ></ejs-richtexteditor>
</div>
  `
})
export class EmojiPickerComponent implements AfterViewInit {
  private readonly emojiService: EmojiPickerService = inject(EmojiPickerService);

  @ViewChild('emojiRTE', {static: true})
  public emojiRTE!: RichTextEditorComponent;

  public toolbarSettings: Record<string, unknown> = {
    items: ['EmojiPicker'],
  };

  public ngAfterViewInit(): void {
    this.emojiService.registerRte(this.emojiRTE);
  }
}
